import { render } from "./Notification.vue?vue&type=template&id=3f33a521&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=3f33a521&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f33a521"],['__file',"src/assets/js/components/Notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f33a521"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f33a521', __exports__)) {
    api.reload('3f33a521', __exports__)
  }
  
  module.hot.accept("./Notification.vue?vue&type=template&id=3f33a521&scoped=true", () => {
    api.rerender('3f33a521', render)
  })

}


export default __exports__